<script>
import Layout from "../../layouts/main";
import InstagramOverview from '../../../components/instagramOverview';
import InstagramPosts from '../../../components/instagramPosts';
import ConnectCard from "../../../components/connectCard";
import axios from 'axios';
import {mapGetters, mapState} from "vuex";
import InstagramStories from "../../../components/instagramStories";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Instagram",
    meta: [{name: "description", content: ''}]
  },
  components: {
    InstagramStories,
    Layout,
    ConnectCard,
    InstagramOverview,
    InstagramPosts
  },
  data() {
    return {
      authResponse: {},
      pages: [],
      showModal: false,
      showError: false,
      errorMessage: 'Something went wrong.'
    };
  },
  computed: {
    ...mapState('user', {
      user: (state) => state.user
    }),
    ...mapGetters('user', ['instagramConnected', 'hasInstagramTokenError']),
    instagram() {
      return this.user.social_network_accounts && this.user.social_network_accounts.instagram;
    },
    connected() {
      return this.instagram && this.instagram !== null;
    },
    initialTab() {
      return this.$route.query.tab;
    }
  },
  created() {
    window.fbAsyncInit = function () {
      FB.init({
        appId: '1201960090286776',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v11.0'
      });
    };
    this.addFacebookScript();
  },
  methods: {
    fbLogin() {
      this.$store.commit('loader/START_LOADING');
      FB.login((response) => {
        // handle the response
        this.authResponse = response.authResponse;
        if (response.status === 'connected') {
          this.getPermissions();
        } else {
          this.$store.commit('loader/END_LOADING');
        }

      }, {scope: 'pages_read_engagement,instagram_basic,instagram_manage_insights,pages_show_list,read_insights,pages_manage_metadata,pages_read_user_content'});
    },
    getPermissions() {
      FB.api('/me/permissions', (response) => {
        var declined = [];
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].status === 'declined') {
            declined.push(response.data[i].permission)
          }
        }
        if (declined.length > 0) {
          this.$store.commit('loader/END_LOADING');
          this.errorMessage = 'Declined: ' + declined.toString();
          this.showError = true;
        } else {
          this.getPagesList();
        }
      });
    },
    getPagesList() {
      FB.api(
          `/${this.authResponse.userID}/accounts`,
          'GET', {
            fields: "instagram_business_account{biography,id,ig_id,followers_count,follows_count,media_count,name,profile_picture_url,username,website},access_token,id,about,bio,picture,category,name"
          },
          (response) => {
            if (response && !response.error) {
              if (response.data.length > 0) {
                this.pages = response.data
                    .filter((page) => typeof page.instagram_business_account === 'object')
                    .map((page) => page.instagram_business_account);
                if (this.pages.length > 0) {
                  if (this.instagramConnected) {
                    const pageIds = this.pages.map(page => page.id);
                    if (pageIds.includes(this.user.social_network_accounts.instagram._id)) {
                      this.choosePage(this.user.social_network_accounts.instagram._id);
                    } else {
                      const availableInstagramNames = this.pages.map(page => page.username).join(', ');
                      Swal.fire("Error!", `The connected instagram is not on the list of available. Available accounts: ${availableInstagramNames}`, "error");
                    }
                  } else {
                    this.showModal = true;
                  }
                } else {
                  this.errorMessage = 'No instagram accounts connected with the selected page.';
                  this.showError = true;
                }
              } else {
                this.errorMessage = 'No facebook pages connected with this user.';
                this.showError = true;
              }
            } else {
              this.errorMessage = 'Something went wrong while connecting with facebook.';
              this.showError = true;
            }
            this.$store.commit('loader/END_LOADING');
          }
      );
    },
    addFacebookScript() {
      const facebookScript = document.createElement('script');
      facebookScript.setAttribute('src', 'https://connect.facebook.net/sr_RS/sdk.js');
      facebookScript.setAttribute('async', '');
      facebookScript.setAttribute('defer', '');
      facebookScript.setAttribute('crossorigin', 'anonymous');
      document.body.appendChild(facebookScript);
    },
    async choosePage(instagramID) {
      this.$store.commit('loader/START_LOADING');
      try {
        const url = this.connected ? '/profile/instagram/update-token' : '/profile/instagram/connect'
        await axios.post(url, {
          access_token: this.authResponse.accessToken,
          instagram_user_id: instagramID
        });
        // navigate and force reload
        window.location = '/instagram';
      } catch (err) {
        this.errorMessage = 'Something went wrong.';
        this.showError = true;
      } finally {
        this.$store.commit('loader/END_LOADING');
        this.showModal = false;
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <b-alert
            v-model="showError"
            class="mt-3"
            variant="danger"
            dismissible
        >{{ errorMessage }}
        </b-alert>
      </div>
    </div>
    <div v-if="hasInstagramTokenError" class="row">
      <div class="col-12">
        <b-alert
            class="mt-3"
            variant="danger"
            show=""
            dismissible
        >
          <p>Your instagram token expired!</p>
          <button @click="fbLogin" class="btn btn-sm btn-success">Update token</button>
        </b-alert>
      </div>
    </div>
    <div v-if="connected" class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <b-tabs nav-class="nav-tabs-custom" content-class="text-muted">
              <b-tab :active="!initialTab">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-chart-bar"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Overview</span>
                </template>

                <InstagramOverview/>

              </b-tab>
              <b-tab :active="initialTab === 'posts'">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-images"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Posts</span>
                </template>

                <InstagramPosts/>

              </b-tab>
              <b-tab :active="initialTab === 'stories'">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-camera-retro"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Stories</span>
                </template>
                <InstagramStories/>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <ConnectCard social-network="Instagram" @connect="fbLogin"/>
      </div>
    </div>
    <b-modal v-model="showModal" :title="`Choose your account`" size="lg" hide-footer centered>
      <div class="row my-5 justify-content-center">
        <div class="col-8">
          <button v-for="page in pages" :key="page.name" @click="choosePage(page.id)"
                  class="btn btn-block btn-primary my-3 btn-instagram">
            <img
                class="rounded-circle header-profile-user mr-3"
                :src="page.profile_picture_url"
                alt="Header Avatar"
            />
            {{ page.name }}
          </button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
